export default __webpack_public_path__ + "static/media/features-bag.7e5e9556.svg";